import { render, staticRenderFns } from "./ColumnVisibilityV2.vue?vue&type=template&id=874ea810&"
import script from "./ColumnVisibilityV2.vue?vue&type=script&lang=js&"
export * from "./ColumnVisibilityV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports